<template>
    <div class="detail-row project-detail-history-tab">
        <div class="detail-block">
            <div class="project-contract-list">
                <el-table class="ah-el-data-table" :data="data">
                    <el-table-column prop="crT_DAT" label="編輯日期" width="110">
                        <template slot-scope="scope">
                            {{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="crT_USR" label="編輯人" width="90"> </el-table-column>
                    <el-table-column prop="chG_RSN" label="編輯原因"> </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
